import type { ApiClient } from "./client";
import type { BillPayment } from "./billing";

export type IntentStatus = "created" | "captured" | "failed" | "expired" | "cancelled" | "needs_review";
export interface Intent {
  id: string; billId: string; branchId: string; method: "upi_qr" | "payment_link"; amount: number; currency: string;
  status: IntentStatus; urlOrUri: string; expiresAt: number | null; createdAt: number; updatedAt: number;
}
export interface IntentEnvelope { intent: Intent; bill: { id: string; paymentStatus: string; balance: number } }

export const createIntent = (c: ApiClient, billId: string, v: { method: "upi_qr" | "payment_link"; amount?: number }, idempotencyKey: string) =>
  c.post<{ intent: Intent }>(`/bills/${billId}/payment-intents`, v, { idempotencyKey });
export const getIntent = (c: ApiClient, id: string, signal?: AbortSignal) => c.get<IntentEnvelope>(`/payment-intents/${id}`, undefined, signal);
export const cancelIntent = (c: ApiClient, id: string) => c.post<IntentEnvelope>(`/payment-intents/${id}/cancel`);
export const recheckIntent = (c: ApiClient, id: string) => c.post<IntentEnvelope>(`/payment-intents/${id}/recheck`);
export const resolveIntent = (c: ApiClient, id: string, action: "apply" | "reject", note?: string) =>
  c.post<IntentEnvelope>(`/payment-intents/${id}/resolve`, { action, ...(note ? { note } : {}) });
export const listNeedsReview = (c: ApiClient, billId: string) =>
  c.get<{ intents: Intent[] }>("/payment-intents", { billId, status: "needs_review" }).then((r) => r.intents);

export const listPayments = (c: ApiClient, q: { method?: string; from?: string; to?: string; branchId?: string; cursor?: string }) =>
  c.get<{ payments: BillPayment[]; nextCursor: string | null }>("/payments", { limit: 50, ...q });

export interface Refund {
  id: string; creditNoteId: string | null; paymentId: string | null; amount: number; method: string;
  status: "pending" | "processing" | "processed" | "failed"; createdAt: number; updatedAt: number;
}
export const listRefunds = (c: ApiClient, q: { status?: string; cursor?: string } = {}) =>
  c.get<{ refunds: Refund[]; nextCursor: string | null }>("/refunds", { limit: 50, ...q });
export const executeRefund = (c: ApiClient, id: string, idempotencyKey: string) =>
  c.post<{ refund: Refund }>(`/refunds/${id}/execute`, undefined, { idempotencyKey });

export interface ClassRefundDue { id: string; memberId: string; memberName?: string | null; className: string; date: string; start: string; branchId: string; paymentRef: string | null }
export const listClassRefundsDue = (c: ApiClient) => c.get<{ refundsDue: ClassRefundDue[] }>("/classes/refunds-due").then((r) => r.refundsDue);
